// Used in resource-container.component.html

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from "@angular/core";

// Services/Types/Helpers
import { EditionId } from "@carnegie-learning/common-types";
import { Asset, eBookActivity } from "@carnegie-learning/cure-types";
import { AssetTypeHelper, SelectedAssets } from "cli-types";

@Component({
    selector: "resource-assignables",
    templateUrl: "./resource-assignables.component.html",
    styleUrls: ["./resource-assignables.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResourceAssignablesComponent implements OnChanges {
    @Input() pageAssets: Map<number, Asset>;
    @Input() selectedAssets: SelectedAssets;
    @Input() editionId: EditionId;

    sortedPageAssets: Asset[] = [];

    @Output() updatedSelectedAssets = new EventEmitter<SelectedAssets>();

    constructor(private assetTypeHelper: AssetTypeHelper) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes["pageAssets"]) {
            this.sortedPageAssets = Array.from(this.pageAssets.values()).sort(
                (a: Asset, b: Asset) => {
                    const val1 = (<eBookActivity>a).bookActivityNumber;
                    const val2 = (<eBookActivity>b).bookActivityNumber;
                    return val1 < val2 ? -1 : val1 > val2 ? 1 : 0;
                }
            );
        }
    }

    trackByAssignment(index: number, assignment: any) {
        return assignment.id;
    }

    getIcon(asset: Asset) {
        if (asset.assetActivityTypeId) {
            return this.assetTypeHelper.convertShortAssignableTypeToIconPath(
                asset.assetActivityTypeId
            );
        }
        return this.assetTypeHelper.convertShortAssignableTypeToIconPath(
            asset.assetTypeId
        );
    }

    selectAsset(asset: Asset) {
        const selectedAsset = asset;
        this.selectedAssets = {
            ...this.selectedAssets,
            editionId: this.editionId,
        };
        let tempSelectedAssets: Asset[] = this.selectedAssets.assets;

        if (this.isAssetSelected(selectedAsset)) {
            // remove assignable
            tempSelectedAssets = tempSelectedAssets.filter(
                (item) => item.assetId !== selectedAsset.assetId
            );
        } else {
            // add assignable
            tempSelectedAssets = [...tempSelectedAssets, selectedAsset];
        }
        this.selectedAssets = {
            ...this.selectedAssets,
            assets: tempSelectedAssets,
        };
        this.updatedSelectedAssets.emit(this.selectedAssets);
    }

    isAssetSelected(asset: Asset) {
        return this.selectedAssets.assets.some(
            (val) => val.assetId === asset.assetId
        );
    }
}
